
import {of as observableOf, Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';

@Injectable()
export class PaperworkService {
    sysMessages: any = {
        en: [],
        fr: [],
        es: []
    };
    sysMessagesObservable: any;

    private _sysPulling: boolean = false;

    paperworkMessagesUpdatedSubj: Subject<boolean>;

    constructor(private http: HttpClient,
        private translateService: TranslateService) {

        // Clients should subscribe to this to get any changes to the data.
        this.paperworkMessagesUpdatedSubj = new Subject<boolean>();

        this.initData(this.translateService.currentLang);
        //if language selection is changed, fetch relevant reference data.
        this.translateService.onLangChange.subscribe((event: any) => {
            this.onTranslationChange();
        });

    }

    /**
     * @param langKey
     */
    private initData(langKey: string): Promise<any> {

        this._sysPulling = true;
        let uri: string = environment.uriTTPEndpoint + environment.apiVersion + 'goesapp/reference/data/systemMessages?lang=' + langKey;

        // var promise: Promise<any> = this.http.get(uri)
        //     .map(res => res.json()).toPromise()
        //     .catch(error => observableThrowError('Server error').toPromise());


        // promise.then(res => {
        //     this.sysMessages[langKey] = res;
        //     this._sysPulling = false;
        //     this.paperworkMessagesUpdatedSubj.next(true);
        // });
        const promise = new Promise<any>((resolve, reject) => {
            this.http.get(uri).pipe()
            .toPromise()
            .catch( reject )
            .then(
                res => {
                    this.sysMessages[langKey] = res;
                    this._sysPulling = false;
                    this.paperworkMessagesUpdatedSubj.next(true);

                    resolve(true);
                }
            );
        });

        return promise;

    }

    public getSysMessages(): any {
        return observableOf(this.sysMessages);
    }

    /*
     * Reinitialize the reference data when language changes AND
     * reference data for that language is not available
     */
    private onTranslationChange(): void {
        if ((!this.sysMessages[this.translateService.currentLang] ||
            this.sysMessages[this.translateService.currentLang].length) == 0 &&
            !this._sysPulling) {
            this.initData(this.translateService.currentLang);
        } else {
            if (!this._sysPulling) this.paperworkMessagesUpdatedSubj.next(true);
        }
    }
}